import React from 'react';

import AuthLayout from '../AuthLayout/AuthLayout';
import { Link } from 'shared/lib/SureDesignSystem';
import styles from './UnderConstruction.module.css';

function UnderConstruction() {
  return (
    <AuthLayout
      title="Under Maintenance"
      description="Please contact our support team if you need assistance via the link below."
    >
      <div className={styles.linksColumn}>
        <div className={styles.linksColumnItems}>
          <span>
            <Link
              href="https://support.sureapp.com"
              className={styles.linksColumnItem}
              target="_blank"
              rel="noopener nofollow"
            >
              https://support.sureapp.com
            </Link>
          </span>
        </div>
      </div>
    </AuthLayout>
  );
}

export default UnderConstruction;
